<template>
    <b-card class="py-4">
      <div class="flex flex-col gap-4">
          <div class="flex items-center justify-between">
              <div class="flex items-center gap-2">
                  <Icon name="solar:alt-arrow-down-linear" size="1.5rem" class="text-white transform rotate-0" />
                  <span class="text-white text-lg font-medium">
                    {{ t('profile_about.title') }}
                  </span>
              </div>
              <b-button v-if="isOwner" light size="sm" @click="showForm = 'summary'" data-e2e="profile-description-edit-button">
                  <Icon name="solar:pen-bold-duotone" size="1rem" />
              </b-button>
          </div>
          
          <div class="text-gray-300 text-base leading-relaxed px-1 break-words">
             <p v-if="user.profile.summary" data-e2e="profile-description-value" class="break-words whitespace-pre-wrap">
                {{ user.profile.summary }}
             </p>
             <p v-else class="text-gray-500 italic">
                {{ t('profile_about.no_summary') }}
             </p>
          </div>
      </div>
    </b-card>

    <b-modal-information 
      v-model="modalIsOpen"
      :title="modalTitle"
      :component="showForm === 'summary' ? 'textarea' : 'text-field'"
      v-model:formValue="informationForm"
      @submit="onSubmit"
    />
</template>

<script setup lang="ts">
import BCard from './BCard.vue';
import {authStore} from "~/stores/auth";
import {useProfileStore} from "~/stores/profileStore";
import {useUserStore} from "~/stores/userStore";
import BButton from "~/components/forms/BButton.vue";
import BModalInformation from '../modal/information/BModalInformation.vue';

const { t } = useI18n();

const showForm = ref<string>();
const modalIsOpen = ref<boolean>(false)

const store = authStore()
const profileStore = useProfileStore();
const userStore = useUserStore();
const { user } = storeToRefs(userStore);
const { user: me } = storeToRefs(store);

const { isPreview } = useProfilePreviewMode();
const isOwner = computed(() => !isPreview.value && me.value && user.value && me.value.id === user.value.id);

const informationForm = ref();

watch(() => showForm.value, (newValue) => {
  if (newValue) {
    modalIsOpen.value = true
    if (newValue === 'summary') {
        informationForm.value = user.value.profile.summary;
    }
  }
})

watch(() => modalIsOpen.value, (newValue) => {
  if (!newValue) {
    informationForm.value = undefined
    showForm.value = undefined
  }
})

const onSummarySubmit = async () => {
    if (showForm.value === 'summary') {
        await profileStore.updateProfile(user.value.id, { summary: informationForm.value });
        // Optimistic update or refetch
        if (user.value.profile) user.value.profile.summary = informationForm.value; 
        informationForm.value = null
        showForm.value = null;
        modalIsOpen.value = false;
    }
};

const modalTitle = computed(() => {
  return t('profile_about.edit_description')
})

const onSubmit = () => {
  if (showForm.value === 'summary') {
    onSummarySubmit()
  }
}
</script>